import { FormGroup } from '@angular/forms';
import {
  GetAllRolesResponse,
  UserAdmin,
} from 'src/app/core/models/admin/user-admin.model';
import {
  DEFAULT_LANGUAGE,
  Language,
} from 'src/app/core/models/languages.model';
import { IOption } from '../../form/components/form-select/form-select.model';
import { STATUS_OPTIONS } from '../../shared-constants';

export const CONSTANTS = {
  HEADER: $localize`User Profile`,
  LABELS: {
    USERID: $localize`User Id`,
    HH_SUPERVISOR: $localize`Handheld Supervisor`,
    EMAIL: $localize`Email`,
    LAST_NAME: $localize`Last Name`,
    FIRST_NAME: $localize`First Name`,
    USER_ROLE: $localize`User Role`,
    GROUP: $localize`Group`,
    LOCATION: $localize`Location`,
    ACTIVE: $localize`Active User`,
    EMPLOYEE_ID: $localize`Employee ID`,
  },
  BUTTONS: {
    RESET: $localize`Reset`,
    SAVE: $localize`Save`,
  },
  PLACEHOLDER: {
    USERID: $localize`Enter User Id`,
    EMAIL: $localize`Enter Email`,
    LAST_NAME: $localize`Enter Last Name`,
    FIRST_NAME: $localize`Enter First Name`,
    EMPLOYEE_ID: $localize`Enter Employee ID`,
  },
};

export const ACTIVE_USER_OPTIONS: IOption[] = [
  { label: STATUS_OPTIONS.ACTIVE, value: STATUS_OPTIONS.ACTIVE },
  { label: STATUS_OPTIONS.DEACTIVATED, value: STATUS_OPTIONS.DEACTIVATED },
];

export const LANGUAGE_DEFAULT = {
  label: $localize`Default`,
  value: DEFAULT_LANGUAGE,
};

export const LANGUAGES: IOption[] = [
  { label: $localize`Chinese - ZH`, value: Language.CHINESE },
  { label: $localize`English - EN`, value: Language.ENGLISH },
  { label: $localize`French - FR`, value: Language.FRENCH },
  { label: $localize`German - DE`, value: Language.GERMAN },
  { label: $localize`Spanish - ES`, value: Language.SPANISH },
  { label: $localize`Turkish - TE`, value: Language.TURKISH },
];

export const IDS = {
  USER_ID: 'userId',
  EMPLOYEE_ID: 'employeeId',
  HH_SUPERVISOR: 'handHeld',
  EMAIL: 'email',
  LAST_NAME: 'lastName',
  FIRST_NAME: 'firstName',
  USER_ROLE: 'userRole',
  GROUP: 'group',
  LOCATION: 'location',
  ACTIVE: 'active',
};

export enum FORM_STATUS {
  ADD,
  EDIT,
  VIEW,
  VIEW_EDIT,
}

export type ProfileData = {
  data: UserAdmin;
  formStatus: FORM_STATUS;
  isOwnProfile: boolean;
  disableEmailRole?: boolean;
  showButton?: boolean;
  modalHeader?: string;
  form?: FormGroup;
};

export enum SubmitFormService {
  MY_PROFILE,
  EDIT_USER,
  ADD_USER,
}

export type CloseType = {
  data: UserAdmin;
  onExit: boolean;
  formStatus: FORM_STATUS;
  untouched: boolean;
};

export const MOCK_ALL_ROLES: GetAllRolesResponse = {
  code: 200,
  status: 'success',
  response: {
    roles: [
      {
        id: 32,
        version: 0,
        roleName: 'ROLE_HD',
        rolePriority: '60',
      },
      {
        id: 625312,
        version: 14,
        roleName: 'ROLE_GROUPMANAGER',
        rolePriority: '50',
      },
      {
        id: 27,
        version: 80,
        roleName: 'ROLE_USER',
        rolePriority: '20',
      },
      {
        id: 28,
        version: 5,
        roleName: 'ROLE_LOCMGR',
        rolePriority: '30',
      },
      {
        id: 29,
        version: 2,
        roleName: 'ROLE_GROUP',
        rolePriority: '40',
      },
      {
        id: 2001533,
        version: 0,
        roleName: 'ROLE_RETAIL',
        rolePriority: '10',
      },
      {
        id: 31,
        version: 430,
        roleName: 'ROLE_ADMIN',
        rolePriority: '70',
      },
      {
        id: 58748946,
        version: 27,
        roleName: 'ROLE_GROUPADMIN',
        rolePriority: '65',
      },
      {
        id: 15,
        version: 0,
        roleName: 'ROLE_REPORTS',
        rolePriority: '55',
      },
    ],
  },
};
